/**
 * Cheeky Frog — scroll reveal
 *
 * Fade-and-rise for anything marked [data-cf-reveal]. Children of a
 * [data-cf-reveal-group] are staggered in DOM order.
 *
 * Progressive enhancement: the CSS that hides elements is scoped to
 * `.cf-reveal-ready` on <html>, and that class is only added once this script
 * runs. If JS fails or is blocked, nothing is ever hidden.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-cf-reveal]';
  var GROUP_SELECTOR = '[data-cf-reveal-group]';
  var STAGGER_MS = 60;
  var MAX_STAGGER_STEPS = 8; // cap so long grids don't crawl in

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No IntersectionObserver (or user prefers reduced motion): show everything,
  // never add the hiding class.
  if (!('IntersectionObserver' in window) || prefersReducedMotion) {
    return;
  }

  document.documentElement.classList.add('cf-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    {
      // Fire slightly before the element reaches the viewport so the motion
      // reads as "already settling" rather than "popping in".
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.01,
    }
  );

  function applyStagger(root) {
    (root || document).querySelectorAll(GROUP_SELECTOR).forEach(function (group) {
      var items = group.querySelectorAll(SELECTOR);
      for (var i = 0; i < items.length; i++) {
        var step = Math.min(i, MAX_STAGGER_STEPS);
        items[i].style.setProperty('--cf-reveal-delay', step * STAGGER_MS + 'ms');
      }
    });
  }

  function observe(root) {
    applyStagger(root);
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  // Shopify's theme editor swaps section markup in without a page load.
  // Re-scan the section that changed so reveals still work while editing.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  // A section re-rendered while hidden may never intersect; reveal it outright.
  document.addEventListener('shopify:section:select', function (event) {
    event.target.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add('is-revealed');
    });
  });
})();
